import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyB51Xv5Akz83b__eC-adag6UDKJ4bakIXk",
  authDomain: "amabie-fd1f1.firebaseapp.com",
  databaseURL: "https://amabie-fd1f1.firebaseio.com",
  projectId: "amabie-fd1f1",
  storageBucket: "amabie-fd1f1.appspot.com",
  messagingSenderId: "1037341343532",
  appId: "1:1037341343532:web:aa03972e5be0f7e0f13689",
  measurementId: "G-MJQZRMSHPF"
};

firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();

export const createDocObject = doc => {
  return {
    id: doc.id,
    ...doc.data()
  };
};

export const signIn = () => {
  const provider = new firebase.auth.GoogleAuthProvider();
  return firebase.auth().signInWithPopup(provider);
};

export const signOut = () => {
  return firebase.auth().signOut();
};
